export default __webpack_public_path__ + "84e904b42fb7146c387063e98e26457b.svg";